<template>
  <div
    :class="[ns.b('group'), ns.is('vertical', isVertical)]"
    :style="groupStyle"
    data-component-name="ButtonGroup"
    data-event-name="click"
    @click="handleGroupClick"
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { provide, reactive, toRef, computed } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { buttonGroupProps } from './button-group'
import { buttonGroupContextKey } from './constants'

defineOptions({
  name: 'JdButtonGroup',
})
const props = defineProps(buttonGroupProps)
const isVertical = computed(() => props.direction === 'vertical')
const groupStyle = computed(() => {
  if (isVertical.value) {
    return {
      gap: `${props.spacing}px`,
    }
  }
  return {}
})

provide(
  buttonGroupContextKey,
  reactive({
    size: toRef(props, 'size'),
    type: toRef(props, 'type'),
  })
)
const ns = useNamespace('button')

const handleGroupClick = (e: MouseEvent) => {
  const target = e.target as HTMLElement | null
  if (!target) return

  const buttonEl = target.closest('[data-component-name="Button"]') as HTMLElement | null
  const text =
    buttonEl?.dataset?.eventContent ??
    buttonEl?.dataset?.componentLabel ??
    buttonEl?.textContent?.trim() ??
    ''

  const groupEl = e.currentTarget as HTMLElement
  if (text) {
    groupEl.setAttribute('data-event-content', text)
    groupEl.setAttribute('data-component-label', text)
  } else {
    groupEl.removeAttribute('data-event-content')
    groupEl.removeAttribute('data-component-label')
  }
}
</script>
